import { Form, Formik } from 'formik'
import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo } from 'react'
import { ArrowLeft } from 'react-bootstrap-icons'
import { ActionSchema } from '../../../../../../../schemas/ProjectManager/ActionSchema'
import ReactSelect from '../../../../../../FormComponents/ReactSelect'
import Modal from '../../../../../../Modal/Modal'
import Input from '../../../../../../FormComponents/Input'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'

export default observer(function AddActionModal({ createAction, isOpen, setIsOpen, authentications, submitting }) {
  const { campaign } = useContext(CampaignContext)

  const providerOptions = useMemo(() => {
    const options = []
    authentications.map((authentication => {
      if(authentication.provider === 'instagram') {
        options.push(...[
          { label: `${authentication.username} Instagram Post`, value: 'instagram_post', authentication_id: authentication.id },
          { label: `${authentication.username} Instagram Carousel Post`, value: 'instagram_carousel_post', authentication_id: authentication.id },
          { label: `${authentication.username} Instagram Story`, value: 'instagram_story', authentication_id: authentication.id },
          { label: `${authentication.username} Instagram Reel`, value: 'instagram_reel', authentication_id: authentication.id }])
      } else if(authentication.provider === 'tiktok') {
        options.push({ label: `${authentication.username} Tiktok Video`, value: 'tiktok_video', authentication_id: authentication.id })
      } else if(authentication.provider === 'youtube') {
        options.push(...[
          { label: `${authentication.username} Youtube Video`, value: 'youtube_video', authentication_id: authentication.id },
          { label: `${authentication.username} Youtube Shorts`, value: 'youtube_short', authentication_id: authentication.id },
        ])
      } else if(authentication.provider === 'linkedin') {
        options.push(...[
          { label: `${authentication.username} LinkedIn Beitrag`, value: 'linkedin_post', authentication_id: authentication.id },
          { label: `${authentication.username} LinkedIn Newsletter`, value: 'linkedin_newsletter', authentication_id: authentication.id },
          { label: `${authentication.username} LinkedIn Video`, value: 'linkedin_video', authentication_id: authentication.id }
        ])
      } else if(authentication.provider === 'pinterest') {
        options.push({ label: `${authentication.username} Pinterest Pin`, value: 'pinterest_pin', authentication_id: authentication.id })
      } else if(authentication.provider === 'podcast') {
        options.push({ label: `${authentication.username} Podcast Episode`, value: 'podcast_episode', authentication_id: authentication.id })
      }
    }))
    if (campaign?.platforms?.has?.('other') || campaign?.platforms?.includes?.('other')) {
      options.push({ label: 'Other Collaboration', value: 'other_item' })
    }
    options.push({ label: 'Non Media', value: 'non_media_item' })
    return options
  }, [authentications, authentications.length, campaign?.platforms])

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} hasSideBar>
      <Modal.Body>
        <div className="p-2 w-96">
          <div className="flex justify-between items-center pb-4">
            <h2 className='font-bold text-2xl dark:text-white'>Add Action</h2>
            <Modal.DissmissButton className='flex items-center p-2 rounded-lg hover:bg-gray-200 dark:hover:text-rb-dark-mode dark:text-white'>
              <ArrowLeft className='mr-1 font-bold' /><span className='font-bold dark:text-white dark:hover:text-rb-dark-mode'>Back</span>
            </Modal.DissmissButton>
          </div>
          <Formik
            initialValues={{ action_type: '', name: null, authentication_id: '' }}
            validationSchema={ActionSchema}
            onSubmit={createAction}
          >
            {({ handleBlur, handleChange, values, touched, errors, setFieldValue }) => (
              <Form>
                <div className="w-full flex flex-col">
                  <ReactSelect
                    error={touched.action_type && errors.action_type}
                    name="action_type"
                    label="Action Type"
                    onChange={(option) => {
                      setFieldValue('authentication_id', option.authentication_id || '', true)
                      setFieldValue('action_type', option.value, true)
                    }}
                    onBlur={handleBlur}
                    value={values.action_type}
                    options={providerOptions}
                  />
                  <Input
                    name="name"
                    label="Optional: Custom action name"
                    error={touched.name && errors.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.name}
                  />
                </div>
                <div className="flex justify-between mt-7">
                  <Modal.DissmissButton className='rb-btn-cancel font-bold text-lg ml p-2 px-4 rounded-lg'>
                    <span className='font-bold'>Cancel</span>
                  </Modal.DissmissButton>

                  <button
                    disabled={submitting}
                    type="submit"
                    className={`ml-auto dark:text-rb-dark-mode bg-rb-green text-white font-bold rounded-lg p-2 px-4 submit text-center active:shadow-outer active:shadow-rb-green border-rb-green ${submitting && 'opacity-60'}`}
                  >
                    Save
                  </button>
                </div>
              </Form>
            )}
          </ Formik>
        </div>
      </Modal.Body>
    </Modal>
  )
})